import { Message } from "element-ui";
const USERINFO = {};
const searchUrlList = {
    1: "getAreaInfoDetail", //行政区
    2: "getPlayInfoDetail", //游玩
    3: "getRestaurantInfoDetail", //饭店
    4: "getSpecialtyInfoDetail", //美食
    10: "getAlongWayInfoDetail", //沿途数据
    11: "getBroadcastInfoDetail", //沿途播报
    12: "", //旅行经验
    13: "getDriveTravelRouteInfoDetail", //自驾路线
    14: "getTravelNoteInfoDetail" //游记
  },
  saveUrlList = {
    0: "saveScenicCity", //城市
    1: "saveSuperScenic", //超级景区
    2: "savePlay", //景区saveScenic
    3: "getAttractionsById", //景点
    4: "saveFood", //美食
    5: "saveRestaurant", //餐馆
    6: "", //酒店
    7: "", //出入口
    8: "", //卫生间
    9: "", //停车场
    10: "saveAlongWay", //沿途
    11: "saveDriveTravelRoute", //自驾
    12: "", //节点
    13: "", //游记
    14: "saveBroadcast" //播报
  };

function setChannelData() {
  let origin = "info/",
    dataObj = [
      {
        key: 0, //城市
        url: origin + "getScenicCityByLabel"
      },
      {
        key: 1, //超级景区
        url: origin + "getSuperScenicByLabel"
      },
      {
        key: 2, //景区
        url: origin + "getScenicByLabel"
      },
      {
        key: 3, //景点
        url: origin + "getAttractionsByLabel "
      },
      {
        key: 4, //美食
        url: origin + "getFoodByLabel"
      },
      {
        key: 5, //餐馆
        url: origin + "getRestaurantByLabel"
      },
      {
        key: 6, //酒店
        url: String(origin)
      },
      {
        key: 7, //出入口
        url: String(origin)
      },
      {
        key: 8, //卫生间
        url: String(origin)
      },
      {
        key: 9, //停车场
        url: String(origin)
      },
      {
        key: 10, //沿途数据
        url: origin + "getRestaurantByLabel"
      },
      {
        key: 11, //自驾
        url: origin + "getDriveTravelRouteByLabel"
      },
      {
        key: 12, //节点
        url: String(origin)
      },
      {
        key: 13, //游记
        url: String(origin)
      },
      {
        key: 13, //沿途播报
        url: origin + "getBroadcastById"
      }
    ];

  return dataObj;
}

// 错误提示
function messageErr(message) {
  Message({
    message: message,
    type: "error"
  });
}

/**
 * 正确提示
 * @param {*} message
 */
function messageSuc(message) {
  Message({
    message: message || "操作成功",
    type: "success"
  });
}

/**
 * 异常返回值通用提示
 * add by liujq
 * @param {*返回值} respData
 * @param {*错误提示} errorCode
 */
function callBack(respData, errorCode) {
  if (respData.respCode) {
    if (errorCode[respData.respCode]) {
      messageErr(errorCode[respData.respCode]);
    } else {
      messageErr("服务器异常，请联系客服");
    }
  }
}

const cookieNames = [
  "userInfo_name",
  "userInfo_appId",
  "userInfo_fleetId",
  "userInfo_productId",
  "userInfo_groupId",
  "userInfo_typeId",
  "userInfo_userId",
  "role-id",
  "role-typeid"
];

function isCookieInfo(cookie, router, name) {
  if (cookie.get(name) === undefined) {
    router.push({
      path: "/"
    });
    return;
  }
  return cookie.get(name);
}

function delAllCookie(cookie) {
  cookieNames.forEach(value => {
    cookie.delete(value);
  });
}

function clearInfo(vue) {
  window.localStorage.clear();
  vue.GLOBAL.delAllCookie(vue.$cookie);
}
function setLoginInfo(cookie, router) {
  USERINFO.LOGIN_USER_APPID = isCookieInfo(cookie, router, "userInfo_appId");
  USERINFO.LOGIN_USER_FLEETID = isCookieInfo(
    cookie,
    router,
    "userInfo_fleetId"
  );
  USERINFO.LOGIN_USER_GROUPID = isCookieInfo(
    cookie,
    router,
    "userInfo_groupId"
  );
  USERINFO.LOGIN_USER_PRODUCTID = isCookieInfo(
    cookie,
    router,
    "userInfo_productId"
  );
  USERINFO.LOGIN_USER_TYPEID = isCookieInfo(cookie, router, "userInfo_typeId");
  USERINFO.LOGIN_USER_USERID = isCookieInfo(cookie, router, "userInfo_userId");
  USERINFO.LOGIN_USER_USERNAME = decodeURIComponent(
    isCookieInfo(cookie, router, "userInfo_name")
  );
}

// function formatDate(date, fmt) {
//   if (/(y+)/.test(fmt)) {
//     fmt = fmt.replace(RegExp.$1, `${date.getFullYear()}`.substr(4 - RegExp.$1.length))
//   }
//   let o = {
//     'M+': date.getMonth() + 1,
//     'd+': date.getDate(),
//     'h+': date.getHours(),
//     'm+': date.getMinutes(),
//     's+': date.getSeconds()
//   }

//   for (let k in o) {
//     if (new RegExp(`(${k})`).test(fmt)) {
//       let str = `${o[k]}`

//       fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? str : padLeftZero(str))
//     }
//   }
//   return fmt
// }
// function padLeftZero(str) {
//   return `00${str}`.substr(str.length)
// }

export default {
  searchUrlList,
  saveUrlList,
  setChannelData,
  messageErr,
  messageSuc,
  callBack,
  setLoginInfo,
  USERINFO,
  delAllCookie,
  clearInfo
};
